// Language handling for user-facing release notes.
//
// The notes themselves used to live here as a curated array; they are now rows
// in the backend's release_notes table, authored from /admin/release-notes and
// fetched through lib/releaseNoteQueries. What remains is the language fallback
// the display components share.
//
// Each localized field (summary/title/details) holds per-language text and falls
// back to nl, then to any available language. `details` is Markdown and only
// shows on the full /release-notes page; `summary` is the one-line card teaser.

import type {
  Localized,
  ReleaseNote,
  ReleaseNoteLang,
  ReleaseNoteTag,
} from "lib/releaseNoteQueries";

export type { Localized, ReleaseNote, ReleaseNoteLang, ReleaseNoteTag };

const DEFAULT_LANG: ReleaseNoteLang = "nl";

/** A localized field for the active language: exact → nl → any available. */
export const localized = (field: Localized | undefined, lang: string): string => {
  if (!field) return "";
  const short = lang.slice(0, 2) as ReleaseNoteLang;
  return field[short] ?? field[DEFAULT_LANG] ?? Object.values(field)[0] ?? "";
};
